__turbopack_context__.v({
  "avatarFallback": "JobCardSpotlight-module__ufRQ1q__avatarFallback",
  "avatarImage": "JobCardSpotlight-module__ufRQ1q__avatarImage",
  "avatarPanel": "JobCardSpotlight-module__ufRQ1q__avatarPanel",
  "avatarWrapper": "JobCardSpotlight-module__ufRQ1q__avatarWrapper",
  "bottom": "JobCardSpotlight-module__ufRQ1q__bottom",
  "card": "JobCardSpotlight-module__ufRQ1q__card",
  "cta": "JobCardSpotlight-module__ufRQ1q__cta",
  "ctaIcon": "JobCardSpotlight-module__ufRQ1q__ctaIcon",
  "headings": "JobCardSpotlight-module__ufRQ1q__headings",
  "highlights": "JobCardSpotlight-module__ufRQ1q__highlights",
  "name": "JobCardSpotlight-module__ufRQ1q__name",
  "recruiterLogo": "JobCardSpotlight-module__ufRQ1q__recruiterLogo",
  "recruiterLogoPlaceholder": "JobCardSpotlight-module__ufRQ1q__recruiterLogoPlaceholder",
  "root": "JobCardSpotlight-module__ufRQ1q__root",
  "skill": "JobCardSpotlight-module__ufRQ1q__skill",
  "skillEmoji": "JobCardSpotlight-module__ufRQ1q__skillEmoji",
  "skillsLabel": "JobCardSpotlight-module__ufRQ1q__skillsLabel",
  "skillsList": "JobCardSpotlight-module__ufRQ1q__skillsList",
  "skillsPanel": "JobCardSpotlight-module__ufRQ1q__skillsPanel",
  "title": "JobCardSpotlight-module__ufRQ1q__title",
  "top": "JobCardSpotlight-module__ufRQ1q__top",
});
